import React, { useCallback, useState } from 'react';
import CardInfo from './CardInfo';
import styled from 'styled-components';
import ChangePaymentModal from '../ChangePayment/ChangePaymentModal';
import { Wallet } from '../../../../../../providers/DonorProvider/interfaces';
import { Text } from '../../../common/Text/Text';
import { usePushEvents } from '../../../../../../hooks/PushEvents';
import { paymentChangedOnGiftSummary } from '../../../../../../hooks/PushEvents/clevertapEvents';
import { useDonee, useDonorProfile } from '../../../../../../api';

interface ChangePaymentMethodButtonProps {
    selectedCard: Wallet;
    wallet: Wallet[];
    setCard: (wallet: Wallet) => unknown;
    handleAddPaymentOpen: () => unknown;
}

const StyledDiv = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    button {
        text-align: left;
        flex: 1;
        margin-left: 26px;
        cursor: pointer;
        background: none;
        border: none;
        padding: 0;
        .change-payment-button {
            cursor: pointer;
        }
    }
`;

const ChangePaymentMethodButton: React.FC<ChangePaymentMethodButtonProps> = ({
    handleAddPaymentOpen,
    selectedCard,
    wallet,
    setCard,
}) => {
    const { donorProfile: donor } = useDonorProfile();
    const { donee } = useDonee();
    const { pushEvent } = usePushEvents();
    const [changePaymentOpen, setChangePaymentOpen] = useState<boolean>(false);
    const paymentPresent = wallet.length ? 'Yes' : 'No';

    const handleChangePaymentOpen = useCallback(() => {
        setChangePaymentOpen(true);
        pushEvent(paymentChangedOnGiftSummary, {
            loggedIn: Boolean(donor),
            doneeId: donee?.idShort,
            paymentPresent,
            modalOpen: true,
            reason: 'Change Payment Modal Opened',
        });
    }, [donee?.idShort, donor, paymentPresent, pushEvent]);

    const handleChangePaymentClose = useCallback(() => {
        setChangePaymentOpen(false);
        pushEvent(paymentChangedOnGiftSummary, {
            loggedIn: Boolean(donor),
            doneeId: donee?.idShort,
            paymentPresent,
            modalOpen: false,
            reason: 'Change Payment Modal Closed',
        });
    }, [donee?.idShort, donor, paymentPresent, pushEvent]);

    return (
        <>
            <StyledDiv id="change-payment-method">
                <CardInfo
                    id="change-payment-method-current-card"
                    card={selectedCard}
                />
                <button id="change-payment-method-button">
                    <Text
                        id="change-payment-method-button-label"
                        color={'primaryGuidingViolet'}
                        className={'change-payment-button'}
                        onClick={handleChangePaymentOpen}
                    >
                        Change Payment
                    </Text>
                </button>
            </StyledDiv>
            <ChangePaymentModal
                id="change-payment-modal"
                open={changePaymentOpen}
                wallet={wallet}
                selectedCard={selectedCard}
                setCard={setCard}
                handleModalClose={handleChangePaymentClose}
                handleAddPaymentOpen={handleAddPaymentOpen}
            />
        </>
    );
};

export default ChangePaymentMethodButton;
